<style scoped>
.d-text {
  font-size: 1.25rem;
  vertical-align: middle;
  color: black !important;
}
.mini-text {
  font-size: 0.9rem;
  vertical-align: middle;
  color: black !important;
  cursor: pointer;
}
.sub-th {
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
  font-size: 10px !important;
  white-space: nowrap;
}

.th-ellipsis {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.n-ellipsis {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.th-ellipsis:hover {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  width: 100%;
}
.v-data-table-header-mobile {
  display: none !important;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
}

.first-col {
  width: 75px;
  left: 0px;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
</style>
<template>
  <div>
    <div class="mt-n8 mb-3 ml-6" style="font-size: 1.35rem" color="blue">
      จำนวนการเข้าร่วมกิจกรรม
      <v-divider class="mt-1"></v-divider>
    </div>
    <div class="mx-5">
      <v-row>
        <v-col cols="12" sm="12" lg="3" class="mb-n3 mt-n6">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="ค้นหารหัสID/ชื่อ-นามสกุลหรือกลุ่มที่ต้องการ"
            single-line
            hide-details
          ></v-text-field>
        </v-col>


        <v-col cols="12" sm="12" lg="3" class="mb-n3 mt-n6">
          <v-card-actions>
            <div class="mini-text" @click="export_xls()">
              ดาวน์โหลด
              <v-icon class="mt-2" large>mdi-download</v-icon>
            </div>
          </v-card-actions>
        </v-col>
      </v-row>

      <v-col cols="12" style="text-align: -webkit-right">
        <v-data-table
          dense
          :headers="headers"
          :items="tbl_data"
          class="elevation-1"
          :loading="tbl_load"
          :items-per-page="20"
          loading-text="กำลังเรียกข้อมูล..."
          :search="search"
        >
        </v-data-table>
      </v-col>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import XLSX from "xlsx";
export default {
  name: "CountActivity",
  components: {},
  data() {
    return {
      tbl_data: [],
      search: "",
      searchGroup: "",
      from_project: "ทั้งหมด",
      ss: null,
      tbl_load: true,
      ss_data: [],
      avg_score: 0,
      pass: 0,
      failed: 0,
      headers: [],
    };
  },
  filters: {},
  async created() {
    let head = await this.$token_api.get(`/Count-Activity-season`);
    console.log(head.data.data);
    this.headers.push({ text: "รหัส ID", value: "CID" });
    this.headers.push({ text: "ชื่อ-นามสกุล", value: "FULLNAME" });
    for (let index = 0; index < head.data.data.length; index++) {
      const element = head.data.data[index];
      this.headers.push({ text: element.NAME, value: element.NAME });
    }
    // this.headers.push({ text: "จำนวนการเข้าร่วม", value: "SUMSEASON" });
    this.headers.push({ text: "กลุ่ม", value: "GROUPSEASON" });
    await this.api_table_data();
    
  },

  computed: {},
  methods: {
    api_table_data() {
      this.tbl_load = true;
      this.$token_api
        .get(`/Count-Activity`)
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.tbl_data = result.map((item) => {
              for (const key in item) {
                if (item[key] === 0) {
                  item[key] = "ไม่ได้เข้าร่วม";
                }
              }
              return item;
            });
            this.tbl_load = false;
          }
          if (result.length > 1) {
            this.tbl_data = result.map((item) => {
              for (const key in item) {
                if (item[key] === 1) {
                  item[key] = "เข้าร่วม";
                }
              }
              return item;
            });
          } else {
            this.tbl_load = false;
            this.tbl_data = [];
          }
        })
        .catch((err) => {
          this.tbl_load = false;
          this.tbl_data = [];
        });
    },

    async export_xls() {
      let data = this.tbl_data;
      let xls_json = [];
      if (data.length > 0) {
        let head = await this.$token_api.get(`/Count-Activity-season`);
        const newArray2 = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let obj = {};
          obj["เลขบัตรประชาชน"] = element.CID;
          obj["ชื่อ-นามสกุล"] = element.FULLNAME;
          for (let index2 = 0; index2 < head.data.data.length; index2++) {
            const element2 = head.data.data[index2];
            obj[element2.NAME] = element[element2.NAME];
          }
          obj["จำนวนการเข้าร่วม"] = element.SUMSEASON;

          obj["กลุ่ม"] = element.GROUPSEASON;
          newArray2.push(obj);
        }
        newArray2.forEach((element, i) => {
          xls_json.push(element);
        });

        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, `จำนวนการเข้าร่วมกิจกรรม.xlsx`);
      } else {
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาค้นหาข้อมูลใหม่อีกครั้ง`,
          timer: 2000,
        });
      }
    },


  },
};
</script>
